import React from 'react';
import SingleProduct from '../components/SingleProduct';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function SingleProductPage() {
  return (
    <>
        <Navbar></Navbar>
        <SingleProduct></SingleProduct>
        <Footer></Footer>
    </>
  )
}
